import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const getStatusStyles = (status) => {
  switch (status) {
    case "Done":
      return {
        bg: "#e6fffa",
        border: "#5eead4",
        text: "#0f766e",
        icon: true,
      };
    case "Active":
      return {
        bg: "#ffffff",
        border: "#f43f5e",
        text: "#f43f5e",
        icon: false,
      };
    default:
      return {
        bg: "rgba(255,255,255,0.2)",
        border: "rgba(255,255,255,0.4)",
        text: "#e5e7eb",
        icon: false,
      };
  }
};

const WorkflowStepper = ({ stages, onStepClick, activeStep }) => {
  return (
    <Box
      m={2}
      sx={{
        p: 3,
        borderRadius: "16px",
        background: "linear-gradient(90deg, #38b2ac, #0ea5a4)",
        color: "#fff",
      }}
    >
      <Typography fontWeight={600} mb={2}>
        ✣ MyClinicO Encounter Workflow
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        {stages.map((stage, index) => {
          const styles = getStatusStyles(stage.status);

          return (
            <Box
              key={stage.key}
              sx={{
                flex: 1,
                textAlign: "center",
                position: "relative",
              }}
            >
              {index !== 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 18,
                    left: "-50%",
                    width: "100%",
                    height: "2px",
                    background: "rgba(255,255,255,0.6)",
                    zIndex: 2,
                  }}
                />
              )}

              {stage.key === activeStep && (
                <Box
                  sx={{
                    position: "absolute",
                    top: -20,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 160,
                    height: 120,
                    borderRadius: "16px",
                    background: "rgba(255,255,255,0.08)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.25)",
                    zIndex: 1,
                    pointerEvents: "none",
                    transition: "all 0.3s ease",
                  }}
                />
              )}

              <Box
                onClick={() => onStepClick?.(stage)}
                sx={{
                  position: "relative",
                  zIndex: 3,
                  display: "inline-block",
                  transition: "transform 0.25s ease, box-shadow 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-6px) scale(1.05)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background: styles.bg,
                    border: `2px solid ${styles.border}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  {styles.icon ? (
                    <CheckIcon sx={{ fontSize: 18, color: "#0f766e" }} />
                  ) : (
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      sx={{
                        color:
                          stage.status === "Active" ? "#f43f5e" : "#ffffff",
                      }}
                    >
                      {index + 1}
                    </Typography>
                  )}
                </Box>

                <Typography mt={1} fontWeight={500} fontSize={14}>
                  {stage.title}
                </Typography>

                <Typography
                  fontSize={12}
                  sx={{
                    opacity: stage.status === "Not Done" ? 0.7 : 1,
                    color:
                      stage.status === "Active"
                        ? "#bbf7d0"
                        : stage.status === "Done"
                          ? "#a7f3d0"
                          : "#e5e7eb",
                  }}
                >
                  {stage.status}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default WorkflowStepper;
